export default __webpack_public_path__ + "static/media/rcb_bbb.cb1cf097.png";